export const SET_MESSAGE_COUNT = "SET_MESSAGE_COUNT";
export const INCREASE_UNREAD_MESSAGE_COUNT = "INCREASE_UNREAD_MESSAGE_COUNT";

export const IncreaseUnreadMessageCountAction = () => {
  return { type: INCREASE_UNREAD_MESSAGE_COUNT };
};
